export const TABLE_COLUMNS_NAMES = [
	{ dataIndex: 'id', title: '#', width: '240px', align: 'left' },
	{ dataIndex: 'text', title: 'Наименование' },
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
